import axios from 'axios';

// Détermine l'URL de base en fonction de l'environnement
const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://api.jaapand-e.com/api' // URL de l'API en production
  : 'http://localhost:5000/api';   // URL de l'API en local

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;